import TaskPopup from "../../../../../pages/Tasks/TaskPopup";
import { referenceRenderer } from "../../../../../pages/Tasks/Uitlities";

const PreviewPopupTable = ({ task, hidePopup }) => {
  return (
    <>
      <TaskPopup
        closeModal={hidePopup}
        useTableInAuditTrail={true}
        auditTrailRow={
          <>
            <tr>
              <td>
                <input
                  type="checkbox"
                  checked={task.is_pinned || false}
                  readOnly
                  disabled
                />
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {referenceRenderer(task)}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.tags || "-"}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.task}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.note || "-"}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.status}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.progress || "0"}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.due ? task.due.split("T")[0] : "-"}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.escalate || "0"}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.remind || "0"}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.created_at ? task.created_at.split("T")[0] : "-"}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.assigned_to
                  ? `${task.assigned_to}`.trim() || "-"
                  : "-"}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "3px",
                }}
              >
                {task.owned_by
                  ? `${task.owned_by}`.trim() || "-"
                  : "-"}
              </td>
            </tr>
          </>
        }
      />
    </>
  );
};

export default PreviewPopupTable;

